import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useLocationCache } from '../location'
import { useTantalimMutation } from '../mutation'
import { useConversationCache } from './cache'
import {
  type ConversationUpdateInput,
  type ConversationUpdateSuccess,
  type ConversationData,
  toResponseError,
} from '@terros/common'

type ConversationUpdateType = ConversationUpdateInput['conversation']
export function useUpdateConversation(): UpdateHookResponse<ConversationUpdateType, ConversationData> {
  const cache = useConversationCache()
  const locationCache = useLocationCache()

  const mutation = useTantalimMutation<ConversationUpdateInput, ConversationUpdateSuccess>({
    url: '/conversation/update',
  })

  async function update(updated: ConversationUpdateType): Promise<ConversationData> {
    try {
      const { conversation } = await mutation.mutateAsync({ conversation: updated })
      cache.setItem(conversation)
      if (updated.locationId) locationCache.clearItem(updated.locationId)
      return conversation
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
